import "./AffiliateCenter.css";
import { useState } from "react";

export default function Welcome({ onshowFirst }) {
  const [expanded, setExpanded] = useState(false);
  const [expandedBox, setExpandedBox] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const boxExpansion = () => {
    setExpanded(!expanded);
  };
  const box2Expansion = () => {
    setExpandedBox(!expandedBox);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  return (
    <>
      <div className="welcome_layout">
        <h3 className="welcome_title">Welcome to Affiliate Center</h3>

        <div className="content_section rules_section">
          <h4>Rules</h4>
          <ul className="ac_list">
            <li>
              Follow all anti-spam policies when sharing your affiliate link.
            </li>
            <li>
              Do not use misleading or deceptive advertising practices.
            </li>
            <li>
              Always disclose your relationship with ZEX PR Wire as an affiliate.
            </li>
          </ul>
        </div>

        <div className="content_section terms_section">
          <h4>Terms and Conditions</h4>
          <ul className="ac_list">
            <li>
              Commissions are paid out based on the current affiliate plan.
            </li>
            <li>
              Payouts are processed monthly after reaching the minimum threshold.
            </li>
            <li>
              ZEX PR Wire reserves the right to terminate affiliate accounts violating terms.
            </li>
          </ul>
        </div>

        <div className="ac_policies">
          <div
            className={`policy_card editorial_policy_ac ${expanded ? "expanded" : ""}`}
            onClick={boxExpansion}
          >
            <div className="card_header">
              <h5>Editorial Policy</h5>
              <img
                className="arrow_icon"
                src="/build/img/Icons/down_vector.svg"
                alt="Expand"
                width={25}
                height={25}
              />
            </div>
            <div className="card_body">
              <p>
                ZEX PR Wire's editorial team reviews all press releases before it
                is distributed to ensure that the content is newsworthy and
                accurate in a PR format. The guidelines that are written below
                help your PR get quick approval and distribution in our platform.
                The press releases should have a clear and newsworthy angle and be
                free from spam, direct address and ads hype. It should incorporate
                the following features:
              </p>
            </div>
          </div>

          <div
            className={`policy_card privacy_policy_ac ${expandedBox ? "expanded" : ""}`}
            onClick={box2Expansion}
          >
            <div className="card_header">
              <h5>Privacy Policy</h5>
              <img
                className="arrow_icon"
                src="/build/img/Icons/down_vector.svg"
                alt="Expand"
                width={25}
                height={25}
              />
            </div>
            <div className="card_body">
              <p>
                ZEX PR Wire is committed to guarding the privacy of our visitors.
                We are one of the leading press release distribution services, and
                are committed to beginning and maintaining procedures and policies
                which protects the privacy of our personal information gained from
                our customers, visitors or other prospects on our website. ZEX PR
                Wire is a Press Release distribution service which distributes PR
                on behalf of clients. If you submit a press release for
                distribution through our system, the PR will be broadcasted in its
                entirety. It will include all personal information contained in
                our media contact information. Also, when you submit the PR
                through our platform, you agree to our policy and understand that
                your contact information will be circulated. This policy applies
                to all the websites, services and products offered by ZEX PR Wire.
              </p>
            </div>
          </div>
        </div>

        <div className="ac_footer">
          <label className="ac_checkbox_wrapper">
            <input
              type="checkbox"
              className="ac_checkbox_input"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <span className="checkbox_text">I accept all the above rules and T&C.</span>
          </label>

          <button
            onClick={() => isChecked && onshowFirst()}
            className={`ac_next_btn ${!isChecked ? 'disabled' : ''}`}
            disabled={!isChecked}
          >
            Get Started
          </button>
        </div>
      </div>
    </>
  );
}
